// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1feTp","error":"Textarea_error__11itK","readonly":"Textarea_readonly__17FZo","disabled":"Textarea_disabled__GrMwB"};